import { render, staticRenderFns } from "./BehaviorAnalysis.vue?vue&type=template&id=0277ac88&scoped=true"
import script from "./BehaviorAnalysis.vue?vue&type=script&lang=js"
export * from "./BehaviorAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BehaviorAnalysis.vue?vue&type=style&index=0&id=0277ac88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277ac88",
  null
  
)

export default component.exports